export const notificationEmailName = 'Looop'
export const notificationEmailAddress = 'notify@looop.co'
